import { render, staticRenderFns } from "./BorderCorner.vue?vue&type=template&id=4dd9c8bc&scoped=true&"
import script from "./BorderCorner.vue?vue&type=script&lang=js&"
export * from "./BorderCorner.vue?vue&type=script&lang=js&"
import style0 from "./BorderCorner.vue?vue&type=style&index=0&id=4dd9c8bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd9c8bc",
  null
  
)

export default component.exports